module.exports = __webpack_public_path__ + "img/banner10.b9ad210e.png";